import Instance from "../../../Axios";

const GetPlusResponsaveis = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/responsaveis`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_RESPONSAVEIS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusResponsaveis;
